import { createContext, createElement, useContext, useState, type ReactNode } from "react";

const LANG_KEY = "azmailhub:lang:v1";
type Lang = "vi" | "en";

const dict = {
  vi: {
    "app.title": "AZ Email Smart Hub",
    "footer.line": "Open source · MIT · azsmarthub.com",
    "home.heading": "Email tạm thời, dùng ngay",
    "home.tagline": "Nhận OTP, verify, một lần dùng — không cần đăng ký. Mỗi địa chỉ tự xoá sau 24 giờ.",
    "home.create": "Tạo địa chỉ mới",
    "home.creating": "Đang tạo…",
    "home.modeRandom": "Ngẫu nhiên",
    "home.modeCustom": "Tuỳ chỉnh",
    "home.domain": "Tên miền",
    "home.domainRandom": "Ngẫu nhiên",
    "home.history": "Địa chỉ đã tạo",
    "home.expires": "Hết hạn",
    "home.copy": "Copy",
    "home.removeLocal": "Xoá khỏi danh sách (mail vẫn còn trên server đến khi hết hạn)",
    "inbox.notFound": "Không tìm thấy địa chỉ này trong trình duyệt. Có thể bạn đang ở thiết bị khác hoặc đã xoá lịch sử.",
    "inbox.empty": "Đang lắng nghe… mail mới sẽ tự hiện ở đây.",
    "inbox.emptyHint": "(realtime qua SSE)",
    "inbox.refresh": "Refresh",
    "inbox.untitled": "(không tiêu đề)",
    "inbox.live": "Đang lắng nghe (realtime)",
    "inbox.polling": "Polling 10s",
    "inbox.connecting": "Đang kết nối…",
    "msg.from": "Từ",
    "msg.time": "Thời gian",
    "msg.delete": "Xoá",
    "msg.noBody": "(không có nội dung)",
    "msg.attachments": "Đính kèm",
    "msg.showImages": "Hiện ảnh từ web (có thể bị tracking)",
    "msg.imagesShown": "Đã bật hiển thị ảnh",
    "abuse.title": "Báo cáo lạm dụng",
    "abuse.intro": "Nếu bạn nhận được mail spam, lừa đảo, hoặc địa chỉ azsmarthub.com đang bị dùng để thực hiện hành vi xấu, hãy gửi báo cáo. Mọi báo cáo được xem xét trong 24h.",
    "abuse.address": "Địa chỉ liên quan (tuỳ chọn)",
    "abuse.reason": "Lý do",
    "abuse.reasonHint": "Mô tả tối thiểu 20 ký tự.",
    "abuse.submit": "Gửi báo cáo",
    "abuse.success": "Đã ghi nhận. Cảm ơn bạn.",
    "common.darkMode": "Chế độ tối",
    "common.lightMode": "Chế độ sáng",
    "common.lang": "English",
    "common.back": "Quay lại",
    "common.login": "Đăng nhập",
    "common.account": "Tài khoản",
    "login.title": "Đăng nhập / Đăng ký",
    "login.emailLabel": "Email của bạn",
    "login.emailHint": "Chúng tôi gửi mã 6 chữ số tới email. Không cần mật khẩu.",
    "login.otpLabel": "Mã 6 chữ số",
    "login.otpHint": "Mã có hiệu lực 10 phút. Kiểm tra hộp thư hoặc spam.",
    "login.sendOtp": "Gửi mã",
    "login.sending": "Đang gửi…",
    "login.otpSent": "Đã gửi mã. Kiểm tra email.",
    "login.sendFailed": "Không gửi được mã.",
    "login.verify": "Xác minh",
    "login.verifying": "Đang xác minh…",
    "login.verifyFailed": "Mã không đúng hoặc đã hết hạn.",
    "account.title": "Tài khoản",
    "account.myAddresses": "Hộp thư của tôi",
    "account.createNew": "Tạo địa chỉ mới",
    "account.empty": "Chưa có địa chỉ nào. Bấm 'Tạo địa chỉ mới' ở góc phải.",
    "account.open": "Mở",
    "account.logout": "Đăng xuất",
  },
  en: {
    "app.title": "AZ Email Smart Hub",
    "footer.line": "Open source · MIT · azsmarthub.com",
    "home.heading": "Throwaway email, instant",
    "home.tagline": "Receive OTPs and verifications — no signup. Every address auto-deletes after 24h.",
    "home.create": "Create new address",
    "home.creating": "Creating…",
    "home.modeRandom": "Random",
    "home.modeCustom": "Custom name",
    "home.domain": "Domain",
    "home.domainRandom": "Auto",
    "home.history": "Your addresses",
    "home.expires": "Expires",
    "home.copy": "Copy",
    "home.removeLocal": "Remove from local list (mail stays on server until TTL)",
    "inbox.notFound": "This address isn't on this device. You may be on another browser or cleared history.",
    "inbox.empty": "Listening… new mail will appear here.",
    "inbox.emptyHint": "(realtime via SSE)",
    "inbox.refresh": "Refresh",
    "inbox.untitled": "(no subject)",
    "inbox.live": "Listening (realtime)",
    "inbox.polling": "Polling 10s",
    "inbox.connecting": "Connecting…",
    "msg.from": "From",
    "msg.time": "Time",
    "msg.delete": "Delete",
    "msg.noBody": "(no body)",
    "msg.attachments": "Attachments",
    "msg.showImages": "Load images from the web (may track you)",
    "msg.imagesShown": "Images enabled",
    "abuse.title": "Report abuse",
    "abuse.intro": "If you received spam or phishing, or an azsmarthub.com address is being used for abuse, file a report. We review within 24h.",
    "abuse.address": "Related address (optional)",
    "abuse.reason": "Reason",
    "abuse.reasonHint": "At least 20 characters.",
    "abuse.submit": "Submit report",
    "abuse.success": "Got it. Thanks.",
    "common.darkMode": "Dark mode",
    "common.lightMode": "Light mode",
    "common.lang": "Tiếng Việt",
    "common.back": "Back",
    "common.login": "Sign in",
    "common.account": "Account",
    "login.title": "Sign in / Sign up",
    "login.emailLabel": "Your email",
    "login.emailHint": "We email a 6-digit code. No password needed.",
    "login.otpLabel": "6-digit code",
    "login.otpHint": "Code expires in 10 minutes. Check inbox or spam.",
    "login.sendOtp": "Send code",
    "login.sending": "Sending…",
    "login.otpSent": "Code sent. Check email.",
    "login.sendFailed": "Could not send code.",
    "login.verify": "Verify",
    "login.verifying": "Verifying…",
    "login.verifyFailed": "Code invalid or expired.",
    "account.title": "Account",
    "account.myAddresses": "My mailboxes",
    "account.createNew": "Create new address",
    "account.empty": "No addresses yet. Click 'Create new address' top right.",
    "account.open": "Open",
    "account.logout": "Sign out",
  },
} satisfies Record<Lang, Record<string, string>>;

type Key = keyof (typeof dict)["vi"];

interface Ctx {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (k: Key) => string;
}

const I18nContext = createContext<Ctx | null>(null);

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === "vi" || saved === "en") return saved;
    return navigator.language.startsWith("vi") ? "vi" : "en";
  });
  const setLang = (l: Lang) => {
    localStorage.setItem(LANG_KEY, l);
    setLangState(l);
  };
  const t = (k: Key): string => dict[lang][k];
  return createElement(I18nContext.Provider, { value: { lang, setLang, t } }, children);
}

export function useI18n(): Ctx {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n outside provider");
  return ctx;
}
